import routes from '../routes/routes'
import SignIn from '../views/SignIn'
import ResetPassword from '../views/ResetPassword'
import UpdatePassword from '../views/UpdatePassword'
import Trial from '../views/Trial'
import TrialCustomLabel from '../views/TrialCustomLabel'
import TrialProductionCustomLabel from '../views/TrialProductionCustomLabel'
import Terms from '../views/Terms'
import EmailVerify from '../views/EmailVerify'
import Dashboard from '../views/Dashboard/Dashboard'
import PalletDetails from '../views/PalletDetails'
import StandaloneCases from '../views/StandaloneCases/StandaloneCases'
import StandaloneCaseCreate from '../views/StandaloneCaseCreate'
import PurchaseOrders from '../views/PurchaseOrders/PurchaseOrders'
import PurchaseOrderEnter from '../views/PurchaseOrderEnter'
import PurchaseOrdersImport from '../views/PurchaseOrdersImport'
import PurchaseOrder from '../views/PurchaseOrder'
import PurchaseOrderEdit from '../views/PurchaseOrderEdit'
import InventoryCreate from '../views/InventoryCreate'
import BarePallets from '../views/BarePallets/BarePallets'
import BarePalletCreate from '../views/BarePalletCreate'
import Inventories from '../views/Inventories/Inventories'
import InventoryHistory from '../views/InventoryHistory'
import Inventory from '../views/Inventory'
import Transfer from '../views/Transfer'
import StockOnHand from '../views/StockOnHand'
import BulkTransfer from '../views/BulkTransfer'
import LicensePlates from '../views/LicensePlates'
import LicensePlateUpload from '../views/LicensePlateUpload'
import CustomLabels from '../views/CustomLabels/CustomLabels'
import UserSubscriptions from '../views/UserSubscriptions/UserSubscriptions'
import CustomLabelCreate from '../views/CustomLabelCreate'
import CustomLabel from '../views/CustomLabel'
import CustomLabelPrint from '../views/CustomLabelPrint'
import CustomLabelEdit from '../views/CustomLabelEdit'
import CustomLabelPrintsPaginate from '../views/CustomLabelPrintsPaginate/CustomLabelPrintsPaginate'
import LabelBuilder from '../views/LabelBuilder/LabelBuilder'
import Categories from '../views/Categories'
import CategoryCreate from '../views/CategoryCreate'
import CategoryEdit from '../views/CategoryEdit'
import LocationCreate from '../views/LocationCreate'
import LocationEdit from '../views/LocationEdit'
import UserCreate from '../views/UserCreate'
import UserEdit from '../views/UserEdit'
import Items from '../views/Items/Items'
import ItemCreate from '../views/ItemCreate'
import ItemEdit from '../views/ItemEdit'
import InventoryReport from '../views/InventoryReport'
import ShippingReport from '../views/ShippingReport'
import PackTraceReport from '../views/PackTraceReport'
import LabelTraceReport from '../views/LabelTraceReport'
import LabelTrace from '../views/LabelTrace'
import InsAndOutsReport from '../views/InsAndOutsReport'
import WorkOrderCreate from '../views/WorkOrderCreate'
import WorkOrder from '../views/WorkOrder'
import PackTraceCreate from '../views/PackTraceCreate/PackTraceCreate'
import PackTraces from '../views/PackTraces/PackTraces'
import PackTrace from '../views/PackTrace'
import ShipOrderPallets from '../views/ShipOrderPallets'
import Users from '../views/Users'
import Locations from '../views/Locations'
import LocationSearch from '../views/LocationSearch'
import Receivings from '../views/Receivings/Receivings'
import ReceivingCreate from '../views/ReceivingCreate'
import WorkOrders from '../views/WorkOrders/WorkOrders'
import WorkOrderCalendar from '../views/WorkOrderCalendar/WorkOrderCalendar'
import WorkOrderEdit from '../views/WorkOrderEdit'
import BillsOfLading from '../views/BillsOfLading/BillsOfLading'
import BillOfLadingGenerate from '../views/BillOfLadingGenerate'
import Ship from '../views/Ship'
import ShipOrders from '../views/ShipOrders/ShipOrders'
import ShipOrderCreate from '../views/ShipOrderCreate'
import ShipOrder from '../views/ShipOrder'
import ShipOrderEdit from '../views/ShipOrderEdit'
import CaseTransfer from '../views/CaseTransfer'
import QuantityTransfer from '../views/QuantityTransfer'
import CaseAssignment from '../views/CaseAssignment'
import Contacts from '../views/Contacts'
import ContactCreate from '../views/ContactCreate'
import ContactEdit from '../views/ContactEdit'
import Logout from '../views/Logout'
import Subscribe from '../views/Subscribe'
import PaymentConfirmation from '../views/PaymentConfirmation'
import SystemLabels from '../views/SystemLabels/SystemLabels'

export default {
  signIn: { path: routes.signIn, view: SignIn },
  resetPassword: { path: routes.resetPassword, view: ResetPassword },
  updatePassword: { path: routes.updatePassword, view: UpdatePassword },
  subscribe: { path: routes.subscribe, view: Subscribe },
  paymentConfirmation: { path: routes.paymentConfirmation, view: PaymentConfirmation },
  trial: { path: routes.trial, view: Trial },
  trialCustomLabel: { path: routes.trialCustomLabel, view: TrialCustomLabel },
  trialProductionCustomLabel: { path: routes.trialProductionCustomLabel, view: TrialProductionCustomLabel },
  terms: { path: routes.terms, view: Terms },
  emailVerify: { path: routes.emailVerify, view: EmailVerify },
  dashboard: { path: routes.dashboard, view: Dashboard },
  palletDetails: { path: routes.palletDetails, view: PalletDetails },
  standaloneCases: { path: routes.standaloneCases, view: StandaloneCases },
  standaloneCaseCreate: { path: routes.standaloneCaseCreate, view: StandaloneCaseCreate },
  purchaseOrders: { path: routes.purchaseOrders, view: PurchaseOrders },
  purchaseOrderEnter: { path: routes.purchaseOrderEnter, view: PurchaseOrderEnter },
  purchaseOrdersImport: { path: routes.purchaseOrdersImport, view: PurchaseOrdersImport },
  purchaseOrder: { path: routes.purchaseOrder, view: PurchaseOrder },
  purchaseOrderEdit: { path: routes.purchaseOrderEdit, view: PurchaseOrderEdit },
  inventoryCreate: { path: routes.inventoryCreate, view: InventoryCreate },
  barePallets: { path: routes.barePallets, view: BarePallets },
  barePalletCreate: { path: routes.barePalletCreate, view: BarePalletCreate },
  inventories: { path: routes.inventories, view: Inventories },
  inventoryHistory: { path: routes.inventoryHistory, view: InventoryHistory },
  inventory: { path: routes.inventory, view: Inventory },
  transfer: { path: routes.transfer, view: Transfer },
  stockOnHand: { path: routes.stockOnHand, view: StockOnHand },
  bulkTransfer: { path: routes.bulkTransfer, view: BulkTransfer },
  licensePlates: { path: routes.licensePlates, view: LicensePlates },
  licensePlateUpload: { path: routes.licensePlateUpload, view: LicensePlateUpload },
  systemLabels: { path: routes.systemLabels, view: SystemLabels },
  customLabels: { path: routes.customLabels, view: CustomLabels },
  userSubscription: { path: routes.userSubscriptions, view: UserSubscriptions },
  customLabelCreate: { path: routes.customLabelCreate, view: CustomLabelCreate },
  customLabel: { path: routes.customLabel, view: CustomLabel },
  customLabelPrint: { path: routes.customLabelPrint, view: CustomLabelPrint },
  customLabelEdit: { path: routes.customLabelEdit, view: CustomLabelEdit },
  customLabelPrintsPaginate: { path: routes.customLabelPrintsPaginate, view: CustomLabelPrintsPaginate },
  labelBuilder: { path: routes.labelBuilder, view: LabelBuilder },
  categories: { path: routes.categories, view: Categories },
  categoryCreate: { path: routes.categoryCreate, view: CategoryCreate },
  categoryEdit: { path: routes.categoryEdit, view: CategoryEdit },
  locationCreate: { path: routes.locationCreate, view: LocationCreate },
  locationEdit: { path: routes.locationEdit, view: LocationEdit },
  userCreate: { path: routes.userCreate, view: UserCreate },
  userEdit: { path: routes.userEdit, view: UserEdit },
  items: { path: routes.items, view: Items },
  itemCreate: { path: routes.itemCreate, view: ItemCreate },
  itemEdit: { path: routes.itemEdit, view: ItemEdit },
  inventoryReport: { path: routes.inventoryReport, view: InventoryReport },
  shippingReport: { path: routes.shippingReport, view: ShippingReport },
  packTraceReport: { path: routes.packTraceReport, view: PackTraceReport },
  labelTraceReport: { path: routes.labelTraceReport, view: LabelTraceReport },
  labelTrace: { path: routes.labelTrace, view: LabelTrace },
  insAndOutsReport: { path: routes.insAndOutsReport, view: InsAndOutsReport },
  workOrderCreate: { path: routes.workOrderCreate, view: WorkOrderCreate },
  workOrder: { path: routes.workOrder, view: WorkOrder },
  packTraceCreate: { path: routes.packTraceCreate, view: PackTraceCreate },
  packTraces: { path: routes.packTraces, view: PackTraces },
  packTrace: { path: routes.packTrace, view: PackTrace },
  shipOrderPallets: { path: routes.shipOrderPallets, view: ShipOrderPallets },
  users: { path: routes.users, view: Users },
  locations: { path: routes.locations, view: Locations },
  locationSearch: { path: routes.locationSearch, view: LocationSearch },
  receivings: { path: routes.receivings, view: Receivings },
  receivingCreate: { path: routes.receivingCreate, view: ReceivingCreate },
  workOrders: { path: routes.workOrders, view: WorkOrders },
  workOrderCalendar: { path: routes.workOrderCalendar, view: WorkOrderCalendar },
  workOrderEdit: { path: routes.workOrderEdit, view: WorkOrderEdit },
  ship: { path: routes.ship, view: Ship },
  shipOrders: { path: routes.shipOrders, view: ShipOrders },
  shipOrderCreate: { path: routes.shipOrderCreate, view: ShipOrderCreate },
  shipOrder: { path: routes.shipOrder, view: ShipOrder },
  shipOrderEdit: { path: routes.shipOrderEdit, view: ShipOrderEdit },
  billsOfLading: { path: routes.billsOfLading, view: BillsOfLading },
  billOfLadingGenerate: { path: routes.billOfLadingGenerate, view: BillOfLadingGenerate },
  caseTransfer: { path: routes.caseTransfer, view: CaseTransfer },
  quantityTransfer: { path: routes.quantityTransfer, view: QuantityTransfer },
  caseAssignment: { path: routes.caseAssignment, view: CaseAssignment },
  contacts: { path: routes.contacts, view: Contacts },
  contactCreate: { path: routes.contactCreate, view: ContactCreate },
  contactEdit: { path: routes.contactEdit, view: ContactEdit },
  logout: { path: routes.logout, view: Logout }
}
